import { jsx as _jsx } from "react/jsx-runtime";
import { useExecuteClientsideTool } from '#pplx/frontend/apps/ask/computer-app/bridge/useExecuteClientsideTool.js';
import { useExecuteBrowserTool } from '#pplx/frontend/apps/ask/runtime/useExecuteBrowserTool.js';
import { MiddlewareRegistry } from '#pplx/frontend/stream/StreamComponents.js';
import React, { useCallback, useMemo } from 'react';
/**
 * Middlewares for streams
 */
export const StreamMiddlewares = React.memo(function StreamMiddlewares() {
    const { executeBrowserTool } = useExecuteBrowserTool({
        reason: 'StreamMiddlewares',
    });
    const executeClientsideTool = useExecuteClientsideTool();
    const browserToolMiddleware = useCallback((message, firstEntrySlug) => {
        if (!message || !message.browser_tool) {
            return message;
        }
        executeBrowserTool(message.browser_tool, message.backend_uuid, firstEntrySlug, message.context_uuid);
        // clientside_tool_call (connect_comet_to_asi) messages also carry
        // text/status data that must be ingested — pass through.
        if (message.browser_tool.connect_comet_to_asi_content)
            return message;
        if (message.browser_tool.connect_comet_to_asi)
            return message;
        return;
    }, [executeBrowserTool]);
    const clientsideToolMiddleware = useCallback((message) => {
        if (!message?.clientside_tools?.length)
            return message;
        executeClientsideTool([...message.clientside_tools], message.context_uuid ?? message.backend_uuid, message.backend_uuid);
        return message;
    }, [executeClientsideTool]);
    // TODO: Migrate omnisearch result injection here
    const middlewares = useMemo(() => [browserToolMiddleware, clientsideToolMiddleware], [browserToolMiddleware, clientsideToolMiddleware]);
    return _jsx(MiddlewareRegistry, { middlewares: middlewares });
});
//# sourceMappingURL=StreamMiddlewares.js.map